import {
  Component,
  TemplateRef,
  Input,
  ViewChild,
  DoCheck,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ComponentFactoryResolver,
} from "@angular/core";
// import { Router } from '@angular/router';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPFeaturePackageInsitutionManagementService } from '../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Country } from '../Models/Country';
import { UserData } from '../Models/UserData';
import { State } from '../Models/State';
import { InstitutionData } from '../Models/InstitutionData';
import { ProductPackage } from '../Models/ProductPackage';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';
import { Subscription, forkJoin, of } from 'rxjs';
import { PHBHPFeaturePackageSOPManagementService } from "ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/public_api";
import { catchError, finalize } from 'rxjs/operators';
import { ChecksService } from "ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api";
import { QuickCommentForm } from "ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/models/quickComment-inteface";

@Component({
  selector: "lib-ph-bhp-addinstitution",
  templateUrl: "./ph-bhp-addinstitution.component.html",
  styleUrls: ["./ph-bhp-addinstitution.component.css"],
})
export class PhBhpAddinstitutionComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  userSubscription: Subscription;
  searchText;
  selectins;
  userData: UserData;
  institutionId: number;
  addInstitutionForm: UntypedFormGroup;
  initflag: boolean = true;
  addInstitution: any = {};
  productPackage: Array<ProductPackage>;
  countryList: Array<Country>;
  licenseList: Array<Number>;
  stateList: Array<State>;
  isDisabled: boolean = true;
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild("cancelmodal") cancelmodal: TemplateRef<any>;
  @ViewChild("denyModal") denyModal;
  itemChange: boolean = false;
  saSOPS: any = [];
  caSOPS: any = [];
  // sopChecked = {} as any;
  institution: any;
  saveInsitutionFlag: boolean = false;
  isgroup: boolean;
  webKessStatus: any;
  additionalChanges: any;
  currentLang: string;
  mode: string;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  loadingData: boolean = false;
  selectedCountryName: string = '';
  selectedStateName: string = '';
  selectedAmountLicences: string = '10';
  isSubmitted: boolean = false;
  isPackageSelectionValid: boolean = true;
  selectedInstitutionType: string = 'INSTITUTION_MANAGEMENT.TYPES.NORMAL';
  institutionTypes: any = [
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.DEMO_PUBLIC', value: 'DEMO_PUBLIC' },
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.DEMO_SALES', value: 'DEMO_SALES' },
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.SPECIAL', value: 'SPECIAL' },
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.INACTIVE', value: 'INACTIVE' },
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.NORMAL', value: 'NORMAL' },
    { typeName: 'INSTITUTION_MANAGEMENT.TYPES.TRIAL', value: 'TRIAL' }
  ];
  initialPackageID: number;
  floorPricePermissionValues: any = [
    { floorPriceValue: 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.NOT_CONFIGURED', value: 'NOT_CONFIGURED' },
    { floorPriceValue: 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.YES', value: 'YES' },
    { floorPriceValue: 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.NO', value: 'NO' }
  ];
  selectedFloorPricePermission: string = 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.NOT_CONFIGURED';
  floorPricePermissionValidUntil: Date;

  usageAgreementValues: any = [
    { usageValue: 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED', value: 'NOT_DEFINED' },
    { usageValue: 'INSTITUTION_MANAGEMENT.CONTRACT.YES', value: 'YES' },
    { usageValue: 'INSTITUTION_MANAGEMENT.CONTRACT.NO', value: 'NO' }
  ];
  selectedUsageAgreement: string = 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED';

  dataProcessingValues: any = [
    { processingValue: 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED', value: 'NOT_DEFINED' },
    { processingValue: 'INSTITUTION_MANAGEMENT.CONTRACT.YES', value: 'YES' },
    { processingValue: 'INSTITUTION_MANAGEMENT.CONTRACT.NO', value: 'NO' }
  ];
  selectedDataProcessing: string = 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED';

  // tslint:disable-next-line:max-line-length
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public config: AppConfig,
    private modalService: BsModalService,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    private sopManageService: PHBHPFeaturePackageSOPManagementService,
    public layoutService: PHBHPLayoutPackageService,
    public translate: TranslateService,
    public checkService: ChecksService
  ) { }

  ngOnInit() {

    this.userSubscription = this.config.userSubject
      .asObservable()
      .subscribe((changelang) => {
        this.userData = this.config.userData;
        this.loadData();
      });

    this.layoutService.lang.asObservable().subscribe((lang) => {
      this.currentLang = lang;
    });

    this.licenseList = [10, 15, 20, 25, 30];

    var params = this.activatedRoute.snapshot.params;
    this.mode = this.activatedRoute.snapshot.url[1].path;

    this.institutionId = params.id;

    this.addInstitutionForm = new UntypedFormGroup({
      institutionName: new UntypedFormControl(
        "",
        Validators.compose([Validators.required])
      ),
      isGroup: new UntypedFormControl(false),
      crmNumber: new UntypedFormControl("", Validators.compose([Validators.required])),
      status: new UntypedFormControl(true),
      addressLine1: new UntypedFormControl(""),
      addressLine2: new UntypedFormControl(""),
      city: new UntypedFormControl("", Validators.compose([Validators.required])),
      stateID: new UntypedFormControl(""),
      zipCode: new UntypedFormControl(""),
      countryID: new UntypedFormControl("", Validators.compose([Validators.required])),
      phone: new UntypedFormControl(""),
      fax: new UntypedFormControl(""),
      bedSize: new UntypedFormControl(
        "",
        Validators.compose([Validators.required, Validators.min(1)])
      ),
      packageID: new UntypedFormControl(0, Validators.compose([Validators.required, Validators.min(1)])),
      userLicense: new UntypedFormControl(10),
      listofSOPID: new UntypedFormControl(null),
      isObserveBenchmark: new UntypedFormControl(false),
      isObserveSOPBenchmark: new UntypedFormControl(false),
      shareDataWithHartmann: new UntypedFormControl(true),
      groupID: new UntypedFormControl(0),
      activateWebKess: new UntypedFormControl(null),
      activateConsumption: new UntypedFormControl(null),
      activateObservation: new UntypedFormControl(null),
      activateAutomaticConsumption: new UntypedFormControl(null),
      institutionType: new UntypedFormControl("NORMAL", Validators.compose([Validators.required])),
      pricingComment: new UntypedFormControl(""),
      floorPricePermission: new UntypedFormControl(false),
      floorPricePermissionValidUntil: new UntypedFormControl(null),
      usageAgreementInPlace: new UntypedFormControl(false),
      dataProcessingAgreement: new UntypedFormControl(false),
    });
    this.setupFormChanges();

    this.service.getCountryList().subscribe((res: Array<Country>) => { this.countryList = res; })

    this.productPackage = [
      { packageID: 1, packageName: this.layoutService.translateText('EVALUATION.MY_HYGIENE_SOP'), ListOfFeatures: null, isChecked: false },
      { packageID: 2, packageName: 'Observe', ListOfFeatures: null, isChecked: false },
      { packageID: 3, packageName: 'Hygiene Check', ListOfFeatures: null, isChecked: false },
    ];

    if (this.config.userData) {
      this.userData = this.config.userData;
      this.loadData();
    }
  }

  setupFormChanges() {
    this.addInstitutionForm.get('isGroup').valueChanges.subscribe(isGroup => {
      const cityControl = this.addInstitutionForm.get('city');

      if (isGroup) {
        cityControl.clearValidators();
      } else {
        cityControl.setValidators(Validators.required);
      }
      cityControl.updateValueAndValidity();
    });
  }

  loadData() {
    this.layoutService.showLoader = true;
    this.loadingData = true;
    if (this.mode == 'add') {
      this.loadSOPDetails();
    } else {
      if (this.userData.roleName.roleId > 1) {
        this.addInstitutionForm.get("floorPricePermissionValidUntil").disable();
      }
      this.loadInstitutionData();
    }
  }

  loadSOPDetails() {
    this.sopManageService.getSOPDetails(this.userData.userId, 0, 'published').pipe(
      catchError(error => {
        console.error('Error fetching SOP details:', error);
        return of([]);
      }),
      finalize(() => this.layoutService.showLoader = false)
    ).subscribe(sops => {
      this.processSOPDetails(sops);
    });
  }

  loadInstitutionData() {
    this.service.getInstitutionById(this.institutionId).subscribe((initInstitutionRes: any) => {
      const statesObs = this.service.GetStatesByCountryId(initInstitutionRes[0].institution.countryID).pipe(catchError(error => {
        console.error('Error fetching states by country ID:', error);
        return of([]);
      }));

      const sopsObs = this.sopManageService.getSOPDetails(this.userData.userId, initInstitutionRes[0].institution.countryID, 'published').pipe(catchError(error => {
        console.error('Error fetching SOP details:', error);
        return of([]);
      }));

      forkJoin([statesObs, sopsObs]).pipe(
        finalize(() => this.layoutService.showLoader = false)
      ).subscribe(([statesRes, sopsRes]) => {
        this.processInstitutionData(initInstitutionRes, statesRes, sopsRes);
      });
    });
  }


  processSOPDetails(sops: any) {
    if (this.userData.roleName.roleId == 2) {
      if (this.countryList && this.countryList.length > 0) {
        const userCountry = this.countryList.find(c => c.countryID == (+this.userData.country))
        this.selectedCountryName = userCountry.countryName;
        this.onChangeCountry(userCountry);
      } else {
        this.service.getCountryList().subscribe((res: Array<Country>) => {
          this.countryList = res;
          const userCountry = this.countryList.find(c => c.countryID == (+this.userData.country))
          this.selectedCountryName = userCountry.countryName;
          this.onChangeCountry(userCountry);
        })
      }
    }

    this.saSOPS = sops.filter(s => s.authorType == "sa" && s.type == 'Master');
    this.caSOPS = sops.filter(s => s.authorType == "ca" && s.type == 'Master');
    if (!this.institution) {
      this.institution = { institution: { listofSOPID: [] } };
    }
    this.loadingData = false;
  }

  processInstitutionData(initInstitutionRes: any, statesRes: any, sopsRes: any) {
    this.institution = JSON.parse(JSON.stringify(initInstitutionRes[0]));
    this.setInitialProductPackageCheckboxStates(this.institution.institution.packageID);
    this.initialPackageID = this.institution.institution.packageID;
    this.saSOPS = sopsRes.filter(s => s.authorType == "sa" && s.type == 'Master');
    this.caSOPS = sopsRes.filter(s => s.authorType == "ca" && s.type == 'Master');

    if (this.userData.roleName.roleId == 1 || this.userData.roleName.roleId == 2) {
      if (initInstitutionRes[0].institution && initInstitutionRes[0].institution.additionalChanges) {
        this.additionalChanges = JSON.parse(initInstitutionRes[0].institution.additionalChanges);
        this.webKessStatus = JSON.parse(initInstitutionRes[0].institution.additionalChanges).Status;
      }
    }

    const institutionData = initInstitutionRes[0].institution;
    ['institutionID', 'isDeleted', 'createdBy', 'createdDateTime', 'updatedBy', 'updatedDateTime', 'productPackage', 'isNoSterility'].forEach(key => {
      delete institutionData[key];
    });

    const sopsOfInstitution = this.caSOPS.filter(s => s.sopInstitutions.some(i => i.institutionID == this.institutionId));
    const sopsOfInstitutionSA = this.saSOPS.filter(s => s.sopInstitutions.some(i => i.institutionID == this.institutionId));
    this.institution.institution.listofSOPID = [...sopsOfInstitution, ...sopsOfInstitutionSA].map(s => s.sopid);

    this.addInstitutionForm.patchValue(institutionData);

    if (this.addInstitutionForm) {
      this.addInstitutionForm.get("isGroup").disable();
    }

    if (this.countryList && this.countryList.length > 0) {
      this.selectedCountryName = this.countryList.find(c => c.countryID == this.institution.institution.countryID).countryName;
    } else {
      this.service.getCountryList().subscribe((res: Array<Country>) => {
        this.countryList = res;
        this.selectedCountryName = this.countryList.find(c => c.countryID == this.institution.institution.countryID).countryName;
      })
    }

    this.stateList = statesRes;
    if (this.institutionId) {
      this.addInstitutionForm.patchValue({
        stateID: this.institution.institution.stateID,
      });
      var state = this.stateList.find(s => s.stateID == this.institution.institution.stateID);
      if (state) {
        this.onChangeState(this.stateList.find(s => s.stateID == this.institution.institution.stateID));
      } else if (this.stateList && this.stateList.length > 0) {
        this.onChangeState(this.stateList[0].stateID);
      }
    } else {
      if (this.stateList.length > 0) {
        this.onChangeState(this.stateList[0]);
      } else {
        this.addInstitutionForm.patchValue([]);
        this.addInstitutionForm.get("stateID").disable();
      }
    }

    this.selectedAmountLicences = this.institution.institution.userLicense.toString();

    if (!this.institution) {
      this.institution = { institution: { listofSOPID: [] } };
    }

    this.selectedInstitutionType = this.institutionTypes.find(t => t.value === this.institution.institution.institutionType).typeName;

    if (this.institutionId) {
      this.institutionTypes = this.institutionTypes.filter(type => type.value !== 'DEMO_PUBLIC');
    }

    const foundPermission = this.floorPricePermissionValues.find(
      t => t.value === this.institution.institution.floorPricePermission
    );
    this.selectedFloorPricePermission = foundPermission ? foundPermission.floorPriceValue : 'INSTITUTION_MANAGEMENT.FLOOR_PERMISSION.NOT_CONFIGURED';

    const foundUsage = this.usageAgreementValues.find(
      t => t.value === this.institution.institution.usageAgreementInPlace
    );
    this.selectedUsageAgreement = foundUsage ? foundUsage.usageValue : 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED';

    const foundProcessing = this.dataProcessingValues.find(
      t => t.value === this.institution.institution.dataProcessingAgreement
    );
    this.selectedDataProcessing = foundProcessing ? foundProcessing.processingValue : 'INSTITUTION_MANAGEMENT.CONTRACT.NOT_DEFINED';

    this.loadingData = false;
  }

  ngOnDestroy() {
    if (this.userSubscription) this.userSubscription.unsubscribe();
  }

  // InitCountry() {
  //   // this.service.getCountryList().subscribe((res: Array<Country>) => {
  //   //   this.countryList = res;
  //   // });

  //   // this.service
  //   //   .getProductPackages()
  //   //   .subscribe((res: Array<ProductPackage>) => {
  //   //     this.productPackage = res;
  //   //   });

  //   if (this.institutionId) {
  //     return this.service
  //       .getInstitutionById(this.institutionId);
  //   }
  // }

  OnUserChanges() {
    if (
      this.userData &&
      this.addInstitutionForm &&
      this.userData.roleName.roleId === 2
    ) {
      this.addInstitutionForm.patchValue({
        countryID: this.userData.country,
      });

      this.addInstitutionForm.get("countryID").disable();
      // this.onChangeCountry(this.userData.country);
      this.loadData();
    }

    if (this.institutionId && this.addInstitutionForm && this.userData) {
      if (
        this.userData.roleName.roleId == 3 ||
        this.userData.roleName.roleId == 4
      ) {
        this.addInstitutionForm.get("isGroup").disable(),
        this.addInstitutionForm.get("status").disable(),
        this.addInstitutionForm.get("countryID").disable();
      }
    }
  }
  // ? maybe it should be removed
  // checkAll(ev) {
  //   this.saSOPS.forEach((x) => {
  //     this.sopChecked[x.sopid] = ev.target.checked;
  //   });
  //   this.caSOPS.forEach((x) => {
  //     this.sopChecked[x.sopid] = ev.target.checked;
  //   });
  // }

  onChangeFloorPricePermission(floorPrice) {

    if (floorPrice.value !== 'YES') {
      this.addInstitutionForm.get('floorPricePermissionValidUntil')?.setValue(null);
    }
    this.selectedFloorPricePermission = floorPrice.floorPriceValue;
    this.addInstitutionForm.get("floorPricePermission").setValue(floorPrice.value);
  }

  onChangeUsageAgreement(usageAgreement) {
    this.selectedUsageAgreement = usageAgreement.usageValue;
    this.addInstitutionForm.get("usageAgreementInPlace").setValue(usageAgreement.value);
  }

  onChangeDataProcessing(dataProcessing) {
    this.selectedDataProcessing = dataProcessing.processingValue;
    this.addInstitutionForm.get("dataProcessingAgreement").setValue(dataProcessing.value);
  }

  onChangeLicenses(licenses) {
    this.selectedAmountLicences = licenses;
    this.addInstitutionForm.get("userLicense").setValue(licenses);
  }

  onChangeState(state) {
    var stateId = state.stateID;
    this.selectedStateName = state.stateName;
    this.addInstitutionForm.get("stateID").setValue(stateId);
  }

  onChangeCountry(country) {
    var countryId = country.countryID;
    this.selectedCountryName = country.countryName;
    this.addInstitutionForm.get("countryID").setValue(countryId);
    if (this.loadingData) {
      return;
    }
    this.stateList = [];
    this.layoutService.showLoader = true;
    const sopsObs = this.sopManageService.getSOPDetails(this.userData.userId, countryId, 'published')
    const statesObs = this.service.GetStatesByCountryId(countryId)

    forkJoin([statesObs, sopsObs]).subscribe(
      ([statesRes, sopRes]) => {
        this.saSOPS = sopRes.filter(s => s.authorType == "sa" && s.type == 'Master');
        this.caSOPS = sopRes.filter(s => s.authorType == "ca" && s.type == 'Master');
        this.stateList = statesRes;
        this.addInstitutionForm.get("stateID").enable();
        if (this.institutionId) {
          if (this.stateList.length > 0) {
            this.onChangeState(this.stateList[0]);
          } else {
            this.addInstitutionForm.patchValue([]);
            this.addInstitutionForm.get("stateID").disable();
          }
        } else {
          if (this.stateList.length > 0) {
            this.onChangeState(this.stateList[0]);
          } else {
            this.addInstitutionForm.patchValue([]);
            this.addInstitutionForm.get("stateID").disable();
          }
        }
        this.layoutService.showLoader = false;
      }, err => {
        this.layoutService.showLoader = false;
      });
  }

  checkValue(ev) {
    if (ev.target.checked == false) {
      this.selectins = ev.target.checked;
    }
  }

  onChangeWebKess(evt) {
    if (this.addInstitutionForm.get("activateWebKess").value == true) {
      this.addInstitutionForm.patchValue({
        activateConsumption: false,
        activateObservation: false,
      });
    } else {
      this.addInstitutionForm.patchValue({
        activateConsumption: null,
        activateObservation: null,
        activateAutomaticConsumption: null,
      });
    }
  }

  onChangeConsumption(evt) {
    if (this.addInstitutionForm.get("activateConsumption").value == true) {
      this.addInstitutionForm.patchValue({
        activateAutomaticConsumption: false,
      });
    } else {
      this.addInstitutionForm.patchValue({
        activateAutomaticConsumption: null,
      });
    }
  }
  denyReqModal() {
    this.modalRef = this.modalService.show(
      this.denyModal,
      Object.assign({}, { class: "w-420" })
    );
  }

  denyReq() {
    this.layoutService.showLoader = true;
    let putData = {
      institutionId: this.institutionId,
      userId: this.userData.userId,
      languageCode: this.currentLang,
      webUrl: null,
      instAdditionalChanges: null,
      institution: null,
    };
    this.service.denyReq(putData).subscribe(
      (res: any) => {
        if (res) {
          if (res.message) {
            this.layoutService.showSuccess(
              this.layoutService.translateText(res.message)
            );
          }
        }
        this.layoutService.showLoader = false;
        this.webKessStatus = null;
      },
      (err: any) => {
        this.layoutService.showLoader = false;
      }
    );
  }

  submitInsitution(template: TemplateRef<any>) {
    this.validatePackageSelection();
    this.isSubmitted = true;
    let value = this.addInstitutionForm.getRawValue();
    if (value.isGroup == true) {
      this.addInstitutionForm.patchValue({
        bedSize: 0,
        userLicense: 0,
        packageID: null,
      });
    }

    if (this.addInstitutionForm.invalid) {
      return true;
    }

    if (value.activateWebKess) {
      if (!value.activateObservation && !value.activateConsumption) {
        if (this.addInstitutionForm.get("packageID").value == 2 || this.addInstitutionForm.get("packageID").value == 3) {
          this.layoutService.showError(this.layoutService.translateText("WEBKESS_INTEGRATION.ENABLE_OBSERVATIONS_AND_OR_CONSUMPTION_INTERFACE"));
          return false;
        }
      }
    }

    const dateValue = this.addInstitutionForm.get('floorPricePermissionValidUntil')?.value;
    if (dateValue) {
      const date = new Date(dateValue); // Asegurar que sea un objeto Date
      date.setHours(10, 0, 0, 0); //By default, because server changed 00:00 to 23:00 of the previous day.
      this.addInstitutionForm.get('floorPricePermissionValidUntil').setValue(date);
    }

    if (!this.institutionId) {
      if (this.saveInsitutionFlag) {
        return true;
      }
      this.isgroup = this.addInstitutionForm.get("isGroup").value;
      this.saveInsitution(template);
    } else {
      this.updateInsitution();
    }
  }

  saveInsitution(template: TemplateRef<any>) {
    var value: any = this.addInstitutionForm.getRawValue();

    value.createdBy = this.userData.userId;
    value.isDeleted = false;
    value.isNoSterility = true;
    value.listofSOPID = this.institution.institution.listofSOPID;

    this.layoutService.showLoader = true;
    this.service.createInstitution(value).subscribe((res: any) => {
      this.saveInsitutionFlag = true;
      this.institution = res;
      this.refreshDynamicTranslations().then(() => {
        this.layoutService.showLoader = false;
        this.modalRef = this.modalService.show(
          template,
          Object.assign({}, { class: "w-420" })
        );
      });

      // check if institution has a hygiene check license and add predefined comments by country
      if(this.layoutService.isHygieneCheckLicense(this.institution.packageID)) {
        this.checkService.addPredefinedCommentsToInstitution(this.institution.institutionID, this.institution.countryID).subscribe((quickComments: any) => {
          if(quickComments) {
            // console.log(` added ${quickComments.length} predefined comments`);
          }
        });

        this.checkService.addCountryTemplatesToInstitution(this.institution.institutionID, this.institution.countryID).subscribe((templates: any) => {
          if (templates) {
            // console.log(` added ${templates.length} predefined templates`);
          }  
        });
      }
    });
  }

  private async loadTranslationsForSOP(sopId) {
    // Get newly created Translations in case of Duplication of this SOP
    const translations = await this.sopManageService.getTranslationsForSop(sopId, -1).toPromise();

    // list of already loaded languages. We cannot set values for languages that where never loaded.
    // However, we don't need to anyway, since they will be refreshed once they are loaded.
    const loadedLanguages = this.translate.getLangs();
    for (const language in translations) {
      if (!loadedLanguages.includes(language)) {
        continue;
      }

      const entries = translations[language];
      for (const key in entries) {
        const value = entries[key];
        // ignore if key is somehow invalid or value is null or empty string
        if (key && value) {
          this.translate.set(key, value, language);
        }
      }
    }
  }


  updateInsitution() {
    const value: any = this.addInstitutionForm.getRawValue();
    value.institutionID = this.institutionId;
    value.isDeleted = false;
    value.updatedBy = this.userData.userId;
    value.listofSOPID = this.institution.institution.listofSOPID;

    if (
      this.userData.roleName.roleId == 1 ||
      this.userData.roleName.roleId == 2
    ) {
      if (this.additionalChanges) {
        if (value.activateWebKess && this.additionalChanges.ActivateWebKess) {
          delete this.additionalChanges.ActivateWebKess;
        }
        if (
          value.activateObservation &&
          this.additionalChanges.ActivateObservation
        ) {
        }
        if (
          value.activateConsumption &&
          this.additionalChanges.ActivateConsumption
        ) {
          delete this.additionalChanges.ActivateConsumption;
        }
        if (!this.additionalChanges.ActivateWebKess) {
          delete this.additionalChanges.ActivateWebKess;
        }
        if (!this.additionalChanges.ActivateObservation) {
          delete this.additionalChanges.ActivateObservation;
        }
        if (!this.additionalChanges.ActivateConsumption) {
          delete this.additionalChanges.ActivateConsumption;
          value.additionalChanges = null;
        }
      }

      if (!this.layoutService.isHygieneCheckLicense(this.initialPackageID) && this.layoutService.isHygieneCheckLicense(value.packageID)) {
        this.checkService.addPredefinedCommentsToInstitution(this.institution.institution.institutionID, this.institution.institution.countryID).subscribe((quickComments: any) => {
          if(quickComments) {
            // console.log(` added ${quickComments.length} predefined comments`);
          }
        });

        this.checkService.addCountryTemplatesToInstitution(this.institution.institution.institutionID, this.institution.institution.countryID).subscribe((quickComments: any) => {
          if(quickComments) {
            // console.log(` added ${quickComments.length} predefined comments`);
          }
        });
      }

      // HHP-1497
      if (!value.isGroup) {
        if (this.institution.institution.availedUserLicense < 0) {
          let neededLicenses = Math.abs(this.institution.institution.availedUserLicense);
          neededLicenses += this.institution.institution.userLicense;
          if (value.userLicense < neededLicenses) {
            this.layoutService.showError(this.layoutService.translateText("ERROR_MESSAGES.INSTITUTION.NEED_MORE_LICENSES"));
            return;
          }
        }

        var currentUsers = this.institution.institution.userLicense - this.institution.institution.availedUserLicense;
        if (currentUsers > value.userLicense) {
          this.layoutService.showError(this.layoutService.translateText("ERROR_MESSAGES.INSTITUTION.NO_LICENSES_REMAINING"));
          return;
        }
      }
    }

    this.layoutService.showLoader = true;
    this.service
      .updateInstitutionById(
        value,
        this.institutionId,
        this.userData.userId,
        this.currentLang,
        this.userData.roleName.roleId
      )
      .subscribe((res: any) => {
        this.refreshDynamicTranslations().then(() => {
          this.layoutService.showLoader = false;
          this.onChildData("institution");
        });
      });
  }

  private async refreshDynamicTranslations() {
    // reload all currently loaded language to replace keys with the correct values
    // technically we only need to reload the values for the current SOP, but ngx-translate does not provide
    // a usable API to iterate loaded values. Since we are moving indices when adding / removing steps, there are
    // many instances where another step occupies the values of a previous step and there is no easy way to detect
    // this.
    // TODO consider doing translations NOT via ngx-translate inside the SOP editor as creates a
    //  lot of difficulties when synchronizing values.
    this.layoutService.showLoader = true;
    await Promise.all(
      this.translate.getLangs().map(lang =>
        this.translate
          .reloadLang(lang)
          .toPromise()));
  }

  loadTranslations(translations: any) {

    const loadedLanguages = this.translate.getLangs();
    for (const language in translations) {
      if (!loadedLanguages.includes(language)) {
        continue;
      }

      const entries = translations[language];
      for (const key in entries) {
        const value = entries[key];
        // ignore if key is somehow invalid or value is null or empty string
        if (key && value) {
          this.translate.set(key, value, language);
        }
      }
    }

  }

  cancelModal() {
    if (this.addInstitutionForm.dirty) {
      this.openCancelModal(this.cancelmodal);
    } else {
      this.closeInsitution();
    }
  }

  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      cancelmodal,
      Object.assign({}, { class: "w-420" })
    );
  }

  onChildData(emitter) {
    this.router.navigate([emitter]);
  }
  closeInsitution() {
    this.onChildData("institution");
  }

  adduser() {
    this.onChildData(
      `user/addInstitution/${this.institution.institutionID}/${this.institution.isGroup ? 1 : 0
      }`
    );
  }

  closeModal() {
    this.onChildData("institution");
  }

  backToManageInstitution() {
    this.onChildData("institution");
  }


  hideInstitutionType: boolean = false;
  onValidation(data) {
    if (this.userData.roleName.roleId == 1 || this.userData.roleName.roleId == 2) {
      if (this.isgroup != this.addInstitutionForm.get("isGroup").value && this.addInstitutionForm.get("isGroup").value) {
        this.hideInstitutionType = true;
        this.onChangeInstitutionType(this.institutionTypes[3])
      } else if (this.isgroup != this.addInstitutionForm.get("isGroup").value && !this.addInstitutionForm.get("isGroup").value) {
        this.hideInstitutionType = false;
      }
    } else {
      if (this.isgroup != this.addInstitutionForm.get("isGroup").value && this.addInstitutionForm.get("isGroup").value) {
        this.onChangeInstitutionType(this.institutionTypes[3])
      }
    }

    this.isgroup = this.addInstitutionForm.get("isGroup").value;
    if (this.isgroup) {
      this.addInstitutionForm.get("city").clearValidators();
      this.addInstitutionForm.get("city").updateValueAndValidity();
      this.addInstitutionForm.get("packageID").clearValidators();
      this.addInstitutionForm.get("packageID").updateValueAndValidity();
      this.addInstitutionForm.get("bedSize").clearValidators();
      this.addInstitutionForm.get("bedSize").updateValueAndValidity();
    } else {
      this.addInstitutionForm.get("city").setValidators([Validators.required]);
      this.addInstitutionForm.get("city").updateValueAndValidity();
      this.addInstitutionForm.get("packageID").clearValidators();
      this.addInstitutionForm.get("packageID").updateValueAndValidity();
      this.addInstitutionForm
        .get("bedSize")
        .setValidators([Validators.required, Validators.min(1)]);
      this.addInstitutionForm.get("bedSize").updateValueAndValidity();
    }
  }

  fileAccept() {
    // if (this.addInstitutionForm.get('countryID').value == 3) {
    // return "\\d{5}";
    // }
    // else if (this.addInstitutionForm.get('countryID').value == 64) {
    // return "\\d{5}";
    // }
    if (this.addInstitutionForm.get("countryID").value == 185) {
      return "([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})";
    }
    // else if (this.addInstitutionForm.get('countryID').value == 182) {
    // return "\\d{4}([\-]\\d{3})?";
    // }
    else {
      return "^\\d{2,15}(?:[-\\s]\\d{2,6})?$";
    }
  }

  onCheckPackage(event) {
    const packageId = parseInt(event.srcElement.id, 10);
    const packageIndex = this.productPackage.findIndex(pkg => pkg.packageID === packageId);
    if (packageIndex !== -1) {
      this.productPackage[packageIndex].isChecked = !this.productPackage[packageIndex].isChecked;
    }

    const packageSelectionValue = this.calculatePackageSelectionValue();

    this.addInstitutionForm.get('packageID').setValue(packageSelectionValue);

    this.validatePackageSelection();
  }

  calculatePackageSelectionValue() {
    let packageSelectionValue = 0;

    if (this.productPackage[0].isChecked) packageSelectionValue += 1;
    if (this.productPackage[1].isChecked) packageSelectionValue += 2;
    if (this.productPackage[2].isChecked) packageSelectionValue += 4;

    return packageSelectionValue || 0;
  }

  validatePackageSelection() {
    const isAnyPackageChecked = this.productPackage.some(pkg => pkg.isChecked);
    this.isPackageSelectionValid = isAnyPackageChecked;

    if (!isAnyPackageChecked) {
      this.addInstitutionForm.get('packageID').setErrors({ 'required': true });
    } else {
      this.addInstitutionForm.get('packageID').setErrors(null);
    }
  }


  isSOPChecked() {
    return this.productPackage[0].isChecked;
  }

  isObserveChecked() {
    return this.productPackage[1].isChecked;
  }

  isHygieneCheckChecked() {
    return this.productPackage[2].isChecked;
  }

  setInitialProductPackageCheckboxStates(packageID) {
    this.productPackage.forEach(pkg => pkg.isChecked = false);
    switch (packageID) {
      case 1:
        this.productPackage[0].isChecked = true;
        break;
      case 2:
        this.productPackage[1].isChecked = true;
        break;
      case 3:
        this.productPackage[0].isChecked = true;
        this.productPackage[1].isChecked = true;
        break;
      case 4:
        this.productPackage[2].isChecked = true;
        break;
      case 5:
        this.productPackage[0].isChecked = true;
        this.productPackage[2].isChecked = true;
        break;
      case 6:
        this.productPackage[1].isChecked = true;
        this.productPackage[2].isChecked = true;
        break;
      case 7:
        this.productPackage.forEach(pkg => pkg.isChecked = true);
        break;
    }
  }

  public isCountryValid(): boolean {
    return this.addInstitutionForm.controls['countryID'].valid || !this.isSubmitted;
  }

  onChangeInstitutionType(type) {
    this.selectedInstitutionType = type.typeName;
    this.addInstitutionForm.get('institutionType').setValue(type.value);
  }

  isInstitutionTypeValid() {
    return this.addInstitutionForm.controls['institutionType'].valid || !this.isSubmitted;
  }
}
